import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { WorkflowStep } from 'app/models/workflow-step';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { Router } from '@angular/router';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-init-step-details',
  templateUrl: './init-step-details.component.html',
  styleUrls: ['./init-step-details.component.scss']
})
export class InitStepDetailsComponent implements OnInit {
  
  @Output() hideModal: EventEmitter<any> = new EventEmitter<any>();
  
  @ViewChild('initStepDetailsModal', {static: true}) initStepDetailsModal: ModalDirective;

  constructor(public workflowWizardService: WorkflowWizardService,
              private _router: Router) { }

  ngOnInit() {
  } 
  
  show() {
    if (!this.initStepDetailsModal.isShown)
      this.initStepDetailsModal.show();
  }

  hide() {
    if (this.initStepDetailsModal.isShown)
      this.initStepDetailsModal.hide();
  }

  gotoGeneralSettings() {
    this.initStepDetailsModal.hide();
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_FIRST_STEP}`);
  }

  gotoInitialStepCompletionMaterials() {
    this.initStepDetailsModal.hide();
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_SECOND_STEP}`);
  }

  gotoInitialStepCompletionAutoActions() {
    this.initStepDetailsModal.hide();
    this._router.navigateByUrl(`${this.workflowWizardService.baseURL}${this.workflowWizardService.WIZARD_THIRD_STEP}`);
  } 
}
